import DetailsContainer, {
  DetailsVariants,
} from 'pages/terms-and-policies/header/DetailsContainer'
import DetailsFieldLabel from 'pages/terms-and-policies/header/DetailsFieldLabel'
import DetailsFieldValue from 'pages/terms-and-policies/header/DetailsFieldValue'
import { TermsAndPoliciesContactPerson } from 'pages/terms-and-policies/header/TermsAndPoliciesContactPerson'
import { PolicyDocument } from 'pages/terms-and-policies/models'
import { formatDate } from 'pages/terms-and-policies/utils'
import React from 'react'

type TermsAndPoliciesVersionDetailsProps = {
  item?: PolicyDocument
}

export const TermsAndPoliciesVersionDetails = ({
  item,
}: TermsAndPoliciesVersionDetailsProps) => {
  return (
    <DetailsContainer variant={DetailsVariants.Light}>
      <div className='flex flex-col justify-start items-start gap-2'>
        <div className='flex justify-start items-center gap-1.5'>
          <DetailsFieldLabel
            variant={DetailsVariants.Dark}
            text='Date published:'
          />
          <DetailsFieldValue
            variant={DetailsVariants.Dark}
            value={formatDate(item.publish_date)}
          />
        </div>
        <div className='flex justify-start items-center gap-1.5'>
          <DetailsFieldLabel
            variant={DetailsVariants.Dark}
            text='Date updated:'
          />
          <DetailsFieldValue
            variant={DetailsVariants.Dark}
            value={formatDate(item.update_date)}
          />
        </div>
        <div className='flex justify-start items-center gap-1.5'>
          <DetailsFieldLabel
            variant={DetailsVariants.Dark}
            text='Review date:'
          />
          <DetailsFieldValue
            variant={DetailsVariants.Dark}
            value={formatDate(item.review_date)}
          />
        </div>
        <div className='flex justify-start items-center gap-1.5'>
          <DetailsFieldLabel variant={DetailsVariants.Dark} text='Version:' />
          <DetailsFieldValue
            variant={DetailsVariants.Dark}
            value={item.version}
          />
        </div>
      </div>
      <div className='h-[0px] border border-[#001a3d] w-full' />
      <TermsAndPoliciesContactPerson
        variant={DetailsVariants.Light}
        author={item.author ? item.author : null}
      />
    </DetailsContainer>
  )
}
